/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseRegistrationEnrollmentChildViewModel } from "../types/CourseRegistrationEnrollmentChildViewModel.ts";

export const courseRegistrationEnrollmentChildViewModelSchema = z.object({
  companyId: z
    .number()
    .int()
    .describe("ID da empresa vinculada à matrícula. Opcional.")
    .nullish(),
  courseRegistrationId: z.optional(
    z.number().int().describe("ID da matrícula."),
  ),
  studentName: z
    .string()
    .describe(
      "Nome completo do aluno, com RA quando disponível (ex.: 'João Silva - RA123').",
    )
    .nullish(),
  date: z
    .string()
    .datetime()
    .describe("Data de criação da matrícula. Opcional.")
    .nullish(),
  status: z.optional(
    z
      .number()
      .int()
      .describe(
        "Status atual da matrícula. Enum EEnrollmentStatus: `1` = PaymentSelection, `2` = PaymentPending, `3` = ApprovalPending, `4` = Approved, `5` = Activating, `6` = Active, `7` = Transferred, `8` = TransferredInRegistration, `9` = Canceled, `10` = CanceledInRegistration, `11` = Rejected, `12` = FinishedWithPendencies, `13` = Finished, `14` = FinishedWithMonograph, `15` = FinishedWithCertificate, `16` = Blocked.",
      ),
  ),
  statusName: z
    .string()
    .describe("Descrição textual do status da matrícula.")
    .nullish(),
  email: z.string().nullish(),
  cpf: z.string().nullish(),
  personId: z.optional(z.number().int()),
  hasDocuments: z.optional(
    z
      .boolean()
      .describe("Indica se o aluno possui ao menos um documento enviado."),
  ),
  documentationStatus: z.optional(
    z
      .number()
      .int()
      .describe(
        "Status da documentação da matrícula. Enum EDocumentationStatus: `0` = Pending, `1` = Approved, `2` = Rejected, `3` = ApprovedTemporary.",
      ),
  ),
  documentationRequired: z.optional(
    z
      .boolean()
      .describe(
        "Indica se a aprovação de documentação é obrigatória para este curso.",
      ),
  ),
  hasMap: z.optional(z.boolean()),
  scholarshipStatusDescription: z
    .string()
    .describe("Descrição do status de bolsa associado à matrícula. Opcional.")
    .nullish(),
  foreignStatusName: z
    .string()
    .describe("Descrição do status estrangeiro do aluno. Opcional.")
    .nullish(),
  foreignStatus: z
    .number()
    .int()
    .describe(
      "Status estrangeiro do aluno. Opcional. Enum EForeignStatus: `1` = Approved, `2` = PendingDocument, `3` = EquivalenceMade, `4` = Cancelled.",
    )
    .nullish(),
  plan: z
    .string()
    .describe("Nome do plano financeiro ativo da matrícula. Opcional.")
    .nullish(),
}) as unknown as ToZod<CourseRegistrationEnrollmentChildViewModel>;
